import { IconButton } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";

import SVG from "react-inlinesvg";
import BasicDetailsAdmin from "../../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddItem/BasicDetailsAdmin";
import NutritionAdmin from "../../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddItem/NutritionAdmin";
import AllergyAdmin from "../../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddItem/AllergyAdmin";
//import PersonalizationAdmin from "../../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddItem/PersonalizationAdmin";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import {
  get_item_details_from_item_id,
  admin_get_global_catalog,
} from "../../../../../store/actions/SuperAdminActions/adminCreateCatalogue";

function AddItemCatalogue(props) {
  const [step, setStep] = useState(1);
  const handleStep = (newStep) => {
    if (newStep === 2) {
      setStep(2);
    } else if (newStep === 8) {
      setStep(3);
    } else if (newStep === 6) {
      setStep(2);
    } else if (newStep === 5) {
      setStep(4);
    } else if (newStep === 3) {
      setStep(3);
    } else if (newStep === 4) {
      // setStep(3);
    }
  };

  useEffect(() => {
    if (props && props.activeItemId && props.activeItemId.length > 2) {
      const token = props.auth.user.accessToken;
      props.get_item_details_from_item_id(props.activeItemId, token);
    }
  }, [props.activeItemId]);

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      setStep(props.menuCategoryItems.runingTrack);
    }
  }, [props.menuCategoryItems && props.menuCategoryItems.runingTrack]);

  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.admin_get_global_catalog(token);
  }, []);

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row superadmin-pending-chains-vendor">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
              <div className="super-admin-right-side-panel">
                <HomeReusableTopBarNavigation />
                <SuperAdminAddItemMainReusable
                  step={step}
                  setStep={setStep}
                  menuCategoryItems={props.menuCategoryItems}
                />
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

const SuperAdminAddItemMainReusable = (props) => {
  return (
    <React.Fragment>
      <div
        className="onboarding_process_screen-button-map pl-4 pr-4"
        style={{ padding: props.dash && 0 }}
      >
        <div className="f24_700_HelveticaNeue mt-2 mb-4">
          Add Global Food Item
        </div>
        <div className="d-flex align-items-center mobileProgressWraper position-relative">
          {/* <IconButton className="enProgressPrev">
            <SVG
              src={require("../../../../../assets/images/UserManagement/prev.svg")}
            />
          </IconButton> */}
          <div className="nav-scroller mb-4">
            <ul
              className="enStepNav nav list-unstyled d-flex justify-content-between"
              style={{ width: 250 }}
            >
              <li
                className={
                  props.menuCategoryItems &&
                  Object.entries(props.menuCategoryItems).length === 0
                    ? "doing"
                    : "done"
                }
                //className="doing"
              >
                <div className="stepNumber">01</div>
                <div className="text">
                  Basic
                  <br />
                  Details
                </div>
              </li>
              <li
                className={
                  props.menuCategoryItems &&
                  props.menuCategoryItems.currentState >= 2
                    ? "done"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.runingTrack === 2
                    ? "doing"
                    : "todo"
                }
              >
                <div className="stepNumber">02</div>
                <div className="text">Nutrition</div>
              </li>
              <li
                className={
                  props.menuCategoryItems &&
                  props.menuCategoryItems.currentState >= 3
                    ? "done"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.runingTrack === 3
                    ? "doing"
                    : "todo"
                }
              >
                <div className="stepNumber">03</div>
                <div className="text">Allergy</div>
              </li>
              {/* <li
                className={
                  props.menuCategoryItems &&
                  props.menuCategoryItems.currentState >= 4
                    ? "done"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.runingTrack === 4
                    ? "doing"
                    : "todo"
                }
              >
                <div className="stepNumber">04</div>
                <div className="text">Personalization</div>
              </li> */}
            </ul>
          </div>
          {/* <IconButton className="enProgressNext">
            <SVG
              src={require("../../../../../assets/images/UserManagement/next.svg")}
            />
          </IconButton> */}
        </div>

        {props.step === 1 && (
          <BasicDetailsAdmin onChange={(v) => props.setStep(v)} />
        )}
        {props.step === 2 && (
          <NutritionAdmin onChange={(v) => props.setStep(v)} />
        )}
        {props.step === 3 && (
          <AllergyAdmin onChange={(v) => props.setStep(v)} />
        )}
        {/* {props.step === 4 && (
          <PersonalizationAdmin onChange={(v) => props.setStep(v)} />
        )} */}
      </div>
    </React.Fragment>
  );
};

AddItemCatalogue.propTypes = {
  auth: PropTypes.object.isRequired,
  get_item_details_from_item_id: PropTypes.func.isRequired,
  admin_get_global_catalog: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
  menuCategoryItems: state.commonSuperAdmin.menuCategoryItems,
  activeItemId: state.commonSuperAdmin.activeItemId,
});

export default connect(mapStateToProps, {
  get_item_details_from_item_id,
  admin_get_global_catalog,
})(AddItemCatalogue);
